export default __webpack_public_path__ + "static/media/bg(7).8486da0a.jpg";